<template>
    <div class="group">
        <strong>Project Street</strong>
        <div>
            <input v-model="street" placeholder="Filter by street name">
        </div>
    </div>
</template>

<script>
    export default {
        name: "streetFilter",
        data: function () {
            return {
                street: '',
            }
        },
        watch: {
            street: function () {
                this.$emit("input", ['project_street', this.street])
            },
        }
    }
</script>

<style scoped>
    .group {
        padding: 4px 2px;
        color: #FFFFFF;
        background: #64983d;
        font-size: 1.25rem;
        margin-bottom: 1px;
        line-height: 1;
    }
    input {
        border: 1px solid #888;
        font-size: 16px;
        padding: 0.5rem;
    }
</style>